/**
 * Calculates the four explicit DeclineCount thresholds: 1, 3, 5, and the halfway point.
 * All subsequent declines after the halfway point will also trigger a pop-up.
 * @param N The total number of questions (TotalNoQuestions).
 * @returns An array of the four core DeclineCount integers, in ascending order.
 */
export const calculateDeclineThresholds = (N: number): number[] => {
    if (N <= 0) return [];

    // Explicit fixed points
    const T1 = 1;
    const T2 = 3;
    const T3 = 5;

    // T4: Halfway point
    const T4 = Math.ceil(N / 2);

    const thresholds = new Set<number>();

    // Add T1, T2, T3, ensuring they are valid
    if (T1 < N) thresholds.add(T1);
    if (T2 < N) thresholds.add(T2);
    if (T3 < N) thresholds.add(T3);

    // Add T4, ensuring it is a distinct, valid point
    if (T4 > T3 && T4 < N) {
        thresholds.add(T4);
    } else if (T4 < N && !thresholds.has(T4)) {
        // Fallback for cases where T4 might be small (e.g., N=10, T4=5=T3, so T4 is already added or skipped)
        thresholds.add(T4);
    }

    // Sort and return the unique set of explicit points (max 4)
    return Array.from(thresholds).sort((a, b) => a - b);
};